(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["taiwanIdValidator"] = factory();
	else
		root["taiwanIdValidator"] = factory();
})(this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__values": function() { return /* binding */ __values; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
var exports = __webpack_exports__;

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDonateCode = exports.isCellPhoneBarcode = exports.isCDC = exports.isOriginalRC = exports.isNewRC = exports.isRC = exports.isNI = exports.isGUI = exports.isEInvoiceDonateCodeValid = exports.isEInvoiceCellPhoneBarcodeValid = exports.isCitizenDigitalCertificateNumberValid = exports.isOriginalResidentCertificateNumberValid = exports.isNewResidentCertificateNumberValid = exports.isResidentCertificateNumberValid = exports.isNationalIdentificationNumberValid = exports.isGuiNumberValid = void 0;
var tslib_1 = __webpack_require__(655);
function zipWith(a1, a2, f) {
    var length = Math.min(a1.length, a2.length);
    var result = [];
    for (var i = 0; i < length; i++)
        result[i] = f(a1[i], a2[i]);
    return result;
}
function add(a, b) {
    return a + b;
}
function multiply(a, b) {
    return a * b;
}
/**
 * Verify the input is a valid GUI Number (中華民國統一編號)
 *
 * @param { string | number } input GUI Number
 * @param { boolean } extended check input using extended format: https://www.fia.gov.tw/singlehtml/6?cntId=aaa97a9dcf2649d5bdd317f554e24f75
 * @returns { boolean } is `input` a valid GUI number
 */
function isGuiNumberValid(input, extended) {
    if (extended === void 0) { extended = false; }
    if (typeof input !== 'string' && typeof input !== 'number')
        return false;
    /**
     * Example: 12345675
     * Step 1:
     * 1 * 1 = 1
     * 2 * 2 = 4
     * 3 * 1 = 3
     * 4 * 2 = 8
     * 5 * 1 = 5
     * 6 * 2 = 12
     * 7 * 4 = 28
     * 5 * 1 = 5
     *
     * Step 2:
     * 1 -> 1
     * 4 -> 4
     * 3 -> 3
     * 8 -> 8
     * 5 -> 5
     * 12 -> 1 + 2 = 3
     * 28 -> 2 + 8 = 10
     * 5 -> 5
     *
     * Step 3:
     * (1 + 4 + 3 + 8 + 5 + 3 + 10 + 5) % 10 = 9
     */
    var GUI_NUMBER_COEFFICIENTS = [1, 2, 1, 2, 1, 2, 4, 1];
    var n = input.toString();
    var regex = /^\d{8}$/;
    if (!regex.test(n))
        return false;
    /**
     * Step 1: 先把統一編號的每個數字分別乘上對應的係數 (1, 2, 1, 2, 1, 2, 4, 1)
     * Step 2: 再把個別乘積的十位數與個位數相加，得出八個小於 10 的數字
     */
    var intRadix = 10;
    var checksum = zipWith(GUI_NUMBER_COEFFICIENTS, n.split('').map(function (c) { return parseInt(c, intRadix); }), multiply)
        .map(function (n) { return (n % 10) + Math.floor(n / 10); })
        .reduce(add, 0);
    /**
     * Step 3: 檢查把這 8 個數字相加之後計算此和除以 5 or 10 的餘數
     * Step 4:
     *  4-1: 若是餘數為 0，則為正確的統一編號
     *  4-2: 若是餘數為 9，且原統一編號的第七位是 7，則也為正確的統一編號
     */
    var divisor = extended ? 5 : 10;
    return (checksum % divisor === 0 ||
        (parseInt(n.charAt(6), intRadix) === 7 && (checksum + 1) % divisor === 0));
}
exports.isGuiNumberValid = isGuiNumberValid;
/**
 * Verify the input is a valid National identification number (中華民國身分證字號)
 *
 * @param { string } input National identification number
 * @returns { boolean } is `input` a valid national ID number
 */
function isNationalIdentificationNumberValid(input) {
    if (typeof input !== 'string')
        return false;
    var regex = /^[A-Z][1,2]\d{8}$/;
    return regex.test(input) && verifyTaiwanIdIntermediateString(input);
}
exports.isNationalIdentificationNumberValid = isNationalIdentificationNumberValid;
/**
 * Verify the input is a valid resident certificate number (臺灣地區無戶籍國民、外國人、大陸地區人民及香港或澳門居民之專屬代號)
 *
 * @param { string } input resident certificate number
 * @returns { boolean } is `input` a valid resident certificate number
 */
function isResidentCertificateNumberValid(input) {
    if (typeof input !== 'string')
        return false;
    return (isNewResidentCertificateNumberValid(input) ||
        isOriginalResidentCertificateNumberValid(input));
}
exports.isResidentCertificateNumberValid = isResidentCertificateNumberValid;
/**
 * Verify the input is a valid new resident certificate number (臺灣地區無戶籍國民、外國人、大陸地區人民及香港或澳門居民之專屬代號)
 *
 * @param { string } input resident certificate number
 * @returns { boolean } is `input` a valid new resident certificate number
 */
function isNewResidentCertificateNumberValid(input) {
    if (typeof input !== 'string')
        return false;
    var regex = /^[A-Z][8,9]\d{8}$/;
    return regex.test(input) && verifyTaiwanIdIntermediateString(input);
}
exports.isNewResidentCertificateNumberValid = isNewResidentCertificateNumberValid;
/**
 * Verify the input is a original valid resident certificate number (臺灣地區無戶籍國民、外國人、大陸地區人民及香港或澳門居民之專屬代號)
 *
 * @param { string } input resident certificate number
 * @returns { boolean } is `input` a valid original resident certificate number
 */
function isOriginalResidentCertificateNumberValid(input) {
    if (typeof input !== 'string')
        return false;
    var regex = /^[A-Z]{2}\d{8}$/;
    return regex.test(input) && verifyTaiwanIdIntermediateString(input);
}
exports.isOriginalResidentCertificateNumberValid = isOriginalResidentCertificateNumberValid;
/**
 * Verify the input is a valid citizen digital certificate number (自然人憑證)
 *
 * @param { string } input citizen digital certificate number
 * @returns { boolean } is `input` a valid citizen digital certificate number
 */
function isCitizenDigitalCertificateNumberValid(input) {
    if (typeof input !== 'string')
        return false;
    var n = input.toString();
    // 驗證規則為兩碼英文 + 14 碼數字
    var regex = /^[A-Z]{2}\d{14}$/;
    return regex.test(n);
}
exports.isCitizenDigitalCertificateNumberValid = isCitizenDigitalCertificateNumberValid;
/**
 * Verify the input is a valid E-Invoice cell phone barcode (電子發票手機條碼)
 *
 * @param { string } input E-Invoice cell phone barcode
 * @returns { boolean } is `input` a valid e-invoice cell phone barcode
 */
function isEInvoiceCellPhoneBarcodeValid(input) {
    if (typeof input !== 'string')
        return false;
    var n = input.toString();
    /**
     * 總長度為 8 碼
     * 第 1 碼為 /
     * 第 2-8 碼由 0-9 (數字), A-Z (大寫英文字母), .(period), -(hyphen), +(plus) 組成
     */
    var regex = /^\/[\dA-Z.\-+]{7}$/;
    return regex.test(n);
}
exports.isEInvoiceCellPhoneBarcodeValid = isEInvoiceCellPhoneBarcodeValid;
/**
 * Verify the input is a valid E-Invoice donate code (電子發票捐贈碼)
 *
 * @param { string | number } input E-Invoice donate code
 * @returns { boolean } is `input` a valid e-invoice donate code
 */
function isEInvoiceDonateCodeValid(input) {
    if (typeof input !== 'string' && typeof input !== 'number')
        return false;
    var n = input.toString();
    // 總長度為 3-7 碼 0-9 的數字
    var regex = /^[\d]{3,7}$/;
    return regex.test(n);
}
exports.isEInvoiceDonateCodeValid = isEInvoiceDonateCodeValid;
/**
 * Verify the intermediate string for isNationalIdentificationNumberValid and isResidentCertificateNumberValid
 *
 * @param { string } input String to verify
 * @returns { boolean } is `input` a valid Taiwan ID intermediate string
 */
function verifyTaiwanIdIntermediateString(input) {
    var intRadix = 10;
    /**
     *  A=10 台北市     J=18 新竹縣     S=26 高雄縣
     *  B=11 台中市     K=19 苗栗縣     T=27 屏東縣
     *  C=12 基隆市     L=20 台中縣     U=28 花蓮縣
     *  D=13 台南市     M=21 南投縣     V=29 台東縣
     *  E=14 高雄市     N=22 彰化縣     W=32 金門縣*
     *  F=15 台北縣     O=35 新竹市*    X=30 澎湖縣
     *  G=16 宜蘭縣     P=23 雲林縣     Y=31 陽明山
     *  H=17 桃園縣     Q=24 嘉義縣     Z=33 連江縣*
     *  I=34 嘉義市*    R=25 台南縣
     *
     *  Step 1: 英文字母按照上表轉換為數字之後，十位數 * 1 + 個位數 * 9 相加
     */
    var TAIWAN_ID_LOCALE_CODE_LIST = [
        1,
        10,
        19,
        28,
        37,
        46,
        55,
        64,
        39,
        73,
        82,
        2,
        11,
        20,
        48,
        29,
        38,
        47,
        56,
        65,
        74,
        83,
        21,
        3,
        12,
        30 // Z -> 33 -> 1 * 3 + 9 * 3 = 30
    ];
    var RESIDENT_CERTIFICATE_NUMBER_LIST = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        4,
        8,
        9,
        0,
        1,
        2,
        5,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        2,
        0,
        1,
        3 // Z
    ];
    var getCharOrder = function (s, i) {
        return s.charCodeAt(i) - 'A'.charCodeAt(0);
    };
    var firstDigit = TAIWAN_ID_LOCALE_CODE_LIST[getCharOrder(input, 0)];
    var secondDigit = isNaN(parseInt(input[1], intRadix)) // if is not a number (舊版居留證編號)
        ? RESIDENT_CERTIFICATE_NUMBER_LIST[getCharOrder(input, 1)]
        : parseInt(input[1], intRadix);
    var rest = input
        .substr(2)
        .split('')
        .map(function (n) { return parseInt(n, intRadix); });
    var idInDigits = tslib_1.__spreadArray([firstDigit, secondDigit], rest);
    // Step 2: 第 1 位數字 (只能為 1 or 2) 至第 8 位數字分別乘上 8, 7, 6, 5, 4, 3, 2, 1 後相加，再加上第 9 位數字
    var ID_COEFFICIENTS = [1, 8, 7, 6, 5, 4, 3, 2, 1, 1];
    var sum = zipWith(idInDigits, ID_COEFFICIENTS, multiply).reduce(add, 0);
    // Step 3: 如果該數字為 10 的倍數，則為正確身分證字號
    return sum % 10 === 0;
}
exports.isGUI = isGuiNumberValid;
exports.isNI = isNationalIdentificationNumberValid;
exports.isRC = isResidentCertificateNumberValid;
exports.isNewRC = isNewResidentCertificateNumberValid;
exports.isOriginalRC = isOriginalResidentCertificateNumberValid;
exports.isCDC = isCitizenDigitalCertificateNumberValid;
exports.isCellPhoneBarcode = isEInvoiceCellPhoneBarcodeValid;
exports.isDonateCode = isEInvoiceDonateCodeValid;

}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.map